import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import Notion from '@famiryru/react-notion-renderer'
import { InitialState } from './types'

export default () => {
  const [pageId, setPageId] = useState<string>(
    '6574eb20b1b64d0284519d981d0489b6'
  )

  const [key, setKey] = useState<string>(
    'secret_Ctdj0QmNBY6MOPUX77BSnVOHcyB5gZxikvTrganoxKj'
  )

  const dispatch = useDispatch()

  const { blocks, isFetching } = useSelector(
    (state: { notion: InitialState }) => state.notion
  )

  useEffect(() => {
    dispatch(actions.destroy())
  }, [])

  const onChangePageId = (event: ChangeEvent<HTMLInputElement>) => {
    setPageId(event.currentTarget.value)
  }

  const onChangeKey = (event: ChangeEvent<HTMLInputElement>) => {
    setKey(event.currentTarget.value)
  }

  const showNotion = () => {
    dispatch(actions.fetchNotionPage(pageId, key))
  }

  return (
    <>
      <label htmlFor={'id'}>pageId</label>
      <br />
      <input
        autoComplete="off"
        style={{ marginBottom: 10 }}
        id={'id'}
        type={'text'}
        value={pageId}
        onChange={onChangePageId}
      />
      <br />
      <label htmlFor={'key'}>Ключ интеграции</label>
      <br />
      <input
        autoComplete="off"
        id={'key'}
        type={'text'}
        value={key}
        onChange={onChangeKey}
      />
      <br />
      <pre>
        {
          'Создайте ключ в https://www.notion.so/my-integrations\nи дайте доступ к новой интеграции в нужном документе\n(Share -> Invite -> Select integration)'
        }
      </pre>
      <button onClick={showNotion}>Показать</button>
      <pre>
        {
          'Для демонстрации работы без сервера используется прокси-сервер \ncors-anywhere.herokuapp.com, чтобы обойти ограничения CORS\n\n'
        }
        Если ваша страница не загружается — запросите временные права на CORS{' '}
        <br />
        здесь{' '}
        <a
          target={'_blank'}
          href="https://cors-anywhere.herokuapp.com/corsdemo"
          rel="noreferrer"
        >
          https://cors-anywhere.herokuapp.com/corsdemo
        </a>{' '}
        и попробуйте снова
      </pre>
      {isFetching ? <pre>Выполняется загрузка...</pre> : null}
      {blocks.length ? (
        <>
          <hr />
          <Notion blocks={blocks} />
        </>
      ) : null}
    </>
  )
}
